import React from 'react';
import { Tag as AntTag, TagProps } from 'antd';
import styles from './Tag.module.scss';
import { combineClasses } from '../../utils';

type Props = TagProps & {
    size?: 'xs' | 'sm' | 'md';
    wrap?: boolean;
    className?: string;
}
const Tag: React.FC<Props> = ({ size, wrap, className, children, ...props }) => {
    return <AntTag {...props} data-size={size} className={combineClasses(styles.tag, wrap ? styles.wrap : null, className)}>
        {children}
    </AntTag>;
}
Tag.defaultProps = {
    size: 'md'
}
export default Tag;